/**
 * [AUTO_IMPORTED] - no need to import to leanist and idist since it is already imported here(idist-components)
 * 
 * Used for searching ex. lean canvases in leanist, tools in idist
 * Used in:
 *  [ic_header]
 * 
 */
import { mapStateVModel } from 'map-state-vmodel';
import { LeanCanvasM } from '@/models/Leanist.js';
import { ToolM } from '@/models/Idist.js';



export default {
  data () {
    return {
      site_model: {
        leanist: LeanCanvasM,
        idist: ToolM
      },
      // siteName: this.site
    }
  },
  watch: {
    searchValue() {
      let self = this
      setTimeout(function () {
        self.search(self.searchValue)
      }, 1000);
    }
  },
  computed: {
    ...mapStateVModel('header', ['searchResult']),
    ...mapStateVModel('site', ['site_name']),
    // checkSite() {
    //   if()
    // }
  },
  methods: {    
    async search(searchValue){
      // console.log('Input Value:' + searchValue);
      if (searchValue) {
        if(!searchValue.replace(/\s/g, '').length) {
          this.searchResult = ''          
        } else {         
          let { data } = await this.site_model[`${this.site_name}`].getParams({ "search": `${searchValue}` })
          this.searchResult = await data.results
        }
      } else {
        this.searchResult = ''
      }
    }
  },
  created() {}
}